export default __webpack_public_path__ + "static/media/hive exchange black 1.bb131957.svg";